export const AGGREGATION_TYPES = {
  SUM: 'sum',
  CALCULATED: 'calc'
}